import { derived } from 'overmind';

export const state = {
  isAuthenticating: false,
  isAuthenticated: derived((state) => state.currentUser != null),
  currentUser: null,
  badges: null
};
